<!-- @component A skeleton loading state for line charts. -->

<script>
  import { LayerCake, Svg } from "layercake";

  import Area from "./_components/Area.svelte";
  import AxisX from "./_components/AxisX.svelte";
  import AxisY from "./_components/AxisY.svelte";
  import Line from "./_components/Line.svelte";
  import { generateRandomLineChartData } from "./skeleton-data";

  const xKey = "myX";
  const yKey = "myY";

  const data = generateRandomLineChartData();
</script>

<div class="w-full h-full animate-pulse">
  <LayerCake
    padding={{ top: 16, right: 16, bottom: 16, left: 16 }}
    x={xKey}
    y={yKey}
    yDomain={[0, null]}
    {data}
  >
    <Svg>
      <AxisX ticks={0} format={() => ""} />
      <AxisY ticks={2} format={() => ""} />
      <Line stroke="#666666" />
      <Area fill="#6666660e" />
    </Svg>
  </LayerCake>
</div>
